<div class="header-label-cell" [class.has-content]="hasContent" [style.background-color]="labelCellConfig.bgColor || 'unset'">
  <div
    (bwClick)="onContainerClick()"
    class="header-label-cell-container"
    [style.min-height]="labelCellConfig.minHeight || 'unset'"
  >
    <div class="header-label-cell-label-wrapper" [ngClass]="{ 'left-content-full-width': labelCellConfig.leftContentFullWidth }">
      <typography-legacy
        class="header-label-cell-title"
        color="var(--primary-text)"
        [ngClass]="{ 'header-label-cell-title--semibold': labelCellConfig.leftTitleSemibold }"
      >
        {{ labelCellConfig.leftTitle }}
      </typography-legacy>
      <typography-legacy text-xsmall-regular class="header-label-cell-subtitle" color="var(--secondary-text)">
        {{ labelCellConfig.leftSubtitle }}
      </typography-legacy>
    </div>
    <div class="header-label-cell-icon" [ngClass]="{ 'left-content-regular-width': !labelCellConfig.leftContentFullWidth }">
      <div *ngIf="labelCellConfig.rightTitle" class="header-label-cell-label-wrapper">
        <typography-legacy
          class="header-label-cell-title"
          color="var(--primary-text)"
          [ngClass]="{ 'header-label-cell-title--semibold': labelCellConfig.rightTitleSemibold }"
        >
          {{ labelCellConfig.rightTitle }}
        </typography-legacy>
        <typography-legacy
          text-xsmall-regular
          class="header-label-cell-subtitle"
          color="var(--secondary-text)"
          [style.white-space]="labelCellConfig.rightSubtitleNoWrap ? 'nowrap' : 'unset'"
        >
          {{ labelCellConfig.rightSubtitle }}
        </typography-legacy>
      </div>
      <ng-container *ngIf="!labelCellConfig.lottieLoading; else lottieLoading">
        <div *ngIf="labelCellConfig.rightIconName && !labelCellConfig.lottie" class="label-cell-icon ml-xs">
          <bw-icon-legacy iconName="{{ labelCellConfig.rightIconName }}" color="{{ labelCellConfig.rightIconColor }}"></bw-icon-legacy>
        </div>
        <div *ngIf="labelCellConfig.lottie && !labelCellConfig.rightIconName" class="animation-container">
          <ng-lottie [options]="labelCellConfig.lottie" [styles]="lottieStyles" (animationCreated)="onAnimationCreated($event)">
          </ng-lottie>
        </div>
      </ng-container>
    </div>
  </div>
  <div #contentWrapper class="content-wrapper" [class.content-wrapper-has-content]="hasContent">
    <ng-content></ng-content>
  </div>
</div>

<ng-template #lottieLoading>
  <ng-lottie
    [options]="lottieLoaderDots"
    [styles]="lottieStyles"
    (animationCreated)="onAnimationCreated($event)">
  </ng-lottie>
</ng-template>
